export default "__VITE_ASSET__BgES$oIi__"